import React from 'react';
import { useHandleChoice } from '../../../hooks/useHandleChoice';
import { LikeIcon } from '../../atoms/like-icon/LikeIcon';
import './ArticleRating.scss';

interface Props {
    articleId: string;
    articleName: string;
}

const ArticleRating = ({ articleId, articleName }: Props) => {
    const { choices, selectedChoice, handleChoice } =
        useHandleChoice(articleId);

    return (
        <div className="m-rating-article">
            <div
                className={`rating-content ${
                    selectedChoice.name ? 'rating-content--open' : ''
                }`}
            >
                <div
                    className={`rating-box ${
                        selectedChoice.name ? 'rating-box--open' : ''
                    }`}
                >
                    <p
                        tabIndex={-1}
                        className={`rating-title ${
                            selectedChoice.name ? 'rating-title--open' : ''
                        }`}
                    >
                        ¿Te resultó útil este contenido?
                    </p>
                    <div className="choices">
                        {choices.map(({ name, value }) => (
                            <div
                                key={name}
                                className={`choices__item ${
                                    value
                                        ? `gtmArticuloLike${articleName?.replace(/ /g, '')}`
                                        : `gtmArticulodislike${articleName?.replace(/ /g, '')}`
                                }`}
                            >
                                <button
                                    className={`${
                                        value
                                            ? `choices__item--like gtmArticuloLike${articleName?.replace(
                                                  / /g,
                                                  ''
                                              )}`
                                            : `gtmArticulodislike${articleName?.replace(/ /g, '')}`
                                    } ${selectedChoice.value === value ? 'selected-choice' : ''}`}
                                    onClick={() => handleChoice(value)}
                                    aria-label={`Responder con un ${name}`}
                                    tabIndex={selectedChoice.name ? -1 : 0}
                                >
                                    <LikeIcon isActive={selectedChoice.name} />
                                </button>
                                <small>{name}</small>
                            </div>
                        ))}
                    </div>
                </div>
                <p
                    className={`rated-message ${selectedChoice.name ? 'open' : 'closed'}`}
                >
                    ¡Gracias por tu respuesta!
                </p>
            </div>
        </div>
    );
};

export default ArticleRating;
